export const ROUTES: {[T: string]: string} = {
	HOME: '/',
	CHAT: '/chat/chat',
	LEAD_FORM: '/forms/lead-form',
	NOTIFICATION: '/notification',
	DEFAULT: '*',
};
